import { createFileRoute } from "@tanstack/react-router";

import { DocumentList } from "@/features/document";

export const Route = createFileRoute("/document/")({
  component: DocumentList,
});
